var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/screen_flash.4b725f28.png","uri@2x": __webpack_public_path__ + "static/media/screen_flash.01e24afc.png","uri@3x": __webpack_public_path__ + "static/media/screen_flash.18f9f04f.png",
    width: 60,
    height: 60
});